import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import { processAdsLeadAttributionOnVisit } from './utils/adsLeadAttributionUtils'

import Layout from './components/Layout'
import Login from './pages/auth/Login'
import Signup from './pages/auth/Signup'
import AgencyDashboard from './pages/AgencyDashboard'
import SMBDashboard from './pages/SMBDashboard'
import Leads from './pages/Leads'
import Conversations from './pages/Conversations'
import Campaigns from './pages/Campaigns'
import Catalog from './pages/Catalog'
import CampaignWizard from './pages/CampaignWizard'
import CampaignDetail from './pages/CampaignDetail'
import Flows from './pages/Flows'
import Automations from './pages/Automations'
import Bookings from './pages/Bookings'
import { Billing } from './pages/Billing'
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './components/admin/AdminDashboard'
import ShopifyOnboarding from './pages/ShopifyOnboarding'
import { AuthProvider } from './contexts/AuthContext'
import { AdminProvider } from './contexts/AdminContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { SMBProvider } from './contexts/SMBContext'
import { PaymentProvider } from './contexts/PaymentContext'

const RootRedirect = () => {
  const location = useLocation()
  return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />
}

function App() {
  useEffect(() => {
    processAdsLeadAttributionOnVisit(window.location.search)
  }, [])

  return (
    <AuthProvider>
      <AdminProvider>
        <NotificationProvider>
          <SMBProvider>
            <PaymentProvider>
              <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
              <Routes>
                {/* Auth routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/shopify/onboarding" element={<ShopifyOnboarding />} />
                
                {/* Protected routes with layout */}
                <Route path="/*" element={<Layout />}>
                  <Route index element={<RootRedirect />} />
                  <Route path="dashboard" element={<SMBDashboard />} />
                  <Route path="billing" element={<Billing />} />
                  <Route path="54ccc109-06aa-44ad-aa08-cfee42f6abbd" element={<AgencyDashboard />} />
                  <Route path="leads" element={<Leads />} />
                  <Route path="conversations" element={<Conversations />} />
                  <Route path="catalog" element={<Catalog />} />
                  <Route path="campaigns" element={<Campaigns />} />
                  <Route path="campaigns/new" element={<CampaignWizard />} />
                  <Route path="campaigns/:id" element={<CampaignDetail />} />
                  <Route path="flows" element={<Flows />} />
                  <Route path="automations" element={<Automations />} />
                  <Route path="bookings" element={<Bookings />} />
                </Route>
              </Routes>
            </Box>
          </PaymentProvider>
        </SMBProvider>
      </NotificationProvider>
      </AdminProvider>
    </AuthProvider>
  )
}

export default App
